<template>
    <div>
        <Navigation></Navigation>
        <div v-if="flash" class="alert alert-success alert-dismissible fade show mb-0" role="alert">
            <strong>Successfully Unsubscribed!</strong>
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <CallToActionA></CallToActionA>

        <DetailA></DetailA>

        <DetailB></DetailB>

        <CallToActionB></CallToActionB>

        <Footer></Footer>
    </div>
</template>

<script>
import Navigation from './sub/Navigation';
import Footer from './sub/Footer';
import CallToActionA from './sub/CallToActionA';
import CallToActionB from './sub/CallToActionB';
import DetailA from './sub/DetailA';
import DetailB from './sub/DetailB';

export default {
    name: 'Home',
    components: {
        Navigation, Footer, CallToActionA, CallToActionB, DetailA, DetailB
    },
    mounted: function() {
        const urlParams  = new URLSearchParams(window.location.search);
        const subscribed = urlParams.get('subscribed');
        if(subscribed) {
            this.flash = true;
        }
    },
    data: function() {
        return {
            flash: false
        }
    }
}
</script>

<!-- Custom Styles -->
<style>

</style>
